import { useState } from 'react'
import { POLICIES_MAP } from '@/store/useApp'
import { SCHOOL_NAMES } from '@/domain/types'

const YEARS = [2026, 2025, 2024, 2023]

function formatBandRange(seg: { upper: number; lower: number }) {
  return `${seg.lower} ≤ 分数 < ${seg.upper}`
}

export function HistoricalSection() {
  const [expandedYear, setExpandedYear] = useState<number | null>(null)

  return (
    <div className="card">
      <div className="overflow-x-auto -mx-2">
        <table className="w-full text-sm tabular-nums">
          <thead>
            <tr className="text-ink-500">
              <th className="text-left font-normal py-2 px-2">年份</th>
              <th className="text-right font-normal py-2 px-2">资格线</th>
              <th className="text-right font-normal py-2 px-2">前300线</th>
              <th className="text-right font-normal py-2 px-2">一中</th>
              <th className="text-right font-normal py-2 px-2">二中</th>
              <th className="text-right font-normal py-2 px-2">实验</th>
              <th className="text-right font-normal py-2 px-2">兖矿</th>
              <th className="text-right font-normal py-2 px-2">孟子湖</th>
            </tr>
          </thead>
          <tbody>
            {YEARS.map((y) => {
              const p = POLICIES_MAP[y]
              return (
                <tr key={y} className="border-t border-ink-100">
                  <td className="py-2.5 px-2 text-ink-800">{y}</td>
                  <td className="text-right py-2.5 px-2">{p.qualification_line}</td>
                  <td className="text-right py-2.5 px-2">{p.top300_line}</td>
                  {SCHOOL_NAMES.map((s) => (
                    <td key={s} className="text-right py-2.5 px-2">
                      {(p.school_ratios[s]! * 100).toFixed(2)}%
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      <div className="mt-5 space-y-2">
        {YEARS.map((y) => {
          const p = POLICIES_MAP[y]
          const isOpen = expandedYear === y
          const showRecommendUsed = p.segments.some((seg) => seg.recommend_used_yz1 > 0)
          return (
            <div key={y} className="border border-ink-100 rounded-xl overflow-hidden">
              <button
                onClick={() => setExpandedYear(isOpen ? null : y)}
                className="w-full px-4 py-3 flex items-center justify-between active:bg-ink-50"
              >
                <span className="text-ink-800">{y} 年 10 分段表</span>
                <span className="text-ink-400 text-sm">{isOpen ? '收起 ▴' : '展开 ▾'}</span>
              </button>
              {isOpen && (
                <div className="px-4 pb-4">
                  <table className="w-full text-sm tabular-nums">
                    <thead className="text-ink-500">
                      <tr>
                        <th className="text-left font-normal py-1.5">分数段</th>
                        <th className="text-right font-normal py-1.5">段内人数</th>
                        {showRecommendUsed && <th className="text-right font-normal py-1.5">一中推荐生占用</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {p.segments.map((seg) => (
                        <tr key={seg.upper} className="border-t border-ink-50">
                          <td className="py-1.5">
                            {formatBandRange(seg)}
                          </td>
                          <td className="text-right py-1.5">{seg.people}</td>
                          {showRecommendUsed && (
                            <td className="text-right py-1.5 text-ink-500">
                              {seg.recommend_used_yz1 || ''}
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {!p.verified.segments && (
                    <p className="text-amber-700 text-xs mt-2 leading-relaxed">
                      ⚠ {y} 年分段表为公开流转整理版，正在与教体局原图复核中。政策行、五校比例已三方核对。
                    </p>
                  )}
                </div>
              )}
            </div>
          )
        })}
      </div>

      <div className="mt-4 text-ink-500 text-sm leading-relaxed">
        数据来源：邹城市教育和体育局历年高中招生工作意见公告。
      </div>
    </div>
  )
}
